var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyAccountPersonalInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22113",
    "data-name": "Group 22113",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.902,
    height: 21.873,
    viewBox: "0 0 21.902 21.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16172",
    "data-name": "Path 16172",
    d: "M190.513,42.3h.214c.325.043.654.043.98.071a7.371,7.371,0,0,1,1.775.434,10.742,10.742,0,0,1,3.212,1.779,11.134,11.134,0,0,1,2.776,3.257,11,11,0,0,1,1.2,3.248,8.148,8.148,0,0,1,.112,1.386,15.966,15.966,0,0,1-.081,2.665,9.858,9.858,0,0,1-1.08,3.221,11.317,11.317,0,0,1-2.1,2.807c-.083.082-.161.192-.309.133a.688.688,0,0,1-.129-.5,7.094,7.094,0,0,0-1.633-4.131,7.2,7.2,0,0,0-2.82-2.111c-.1-.043-.223-.069-.243-.21s.1-.182.177-.247a4.414,4.414,0,0,0,.455-6.527,4.4,4.4,0,0,0-2.966-1.373c-.113-.009-.232-.012-.285-.143a.777.777,0,0,1-.039-.315q0-1.534,0-3.068c0-.132-.022-.275.1-.375h.384a.449.449,0,0,0,.3,0",
    transform: "translate(-178.895 -42.3)",
    fill: "#f5720f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16173",
    "data-name": "Path 16173",
    d: "M10.934,42.3q0,1.9,0,3.791l-.011.031a.724.724,0,0,1-.443.119,4.341,4.341,0,0,0-3.37,2.193,4.188,4.188,0,0,0-.593,2.239,4.388,4.388,0,0,0,.994,2.734,4.162,4.162,0,0,0,.731.712c.095.072.176.148.137.284a.393.393,0,0,1-.22.158A7.242,7.242,0,0,0,4.7,57.55,7.041,7.041,0,0,0,3.726,60.4c-.025.213-.036.425-.041.638,0,.108-.007.218-.132.267-.216.01-.33-.165-.449-.288a11.625,11.625,0,0,1-1.446-1.789A10.962,10.962,0,0,1,.124,55.473a9.625,9.625,0,0,1-.1-1.2c0-.035.006-.071-.022-.1v-.214a.056.056,0,0,0,0-.085v-.854a.337.337,0,0,0,0-.256v-.47c.051-.283.042-.57.069-.855a8.8,8.8,0,0,1,.752-2.633,10.477,10.477,0,0,1,1.773-2.8,11.128,11.128,0,0,1,3-2.433,10.894,10.894,0,0,1,3.044-1.138,10.092,10.092,0,0,1,1.261-.116c.048,0,.1.016.143-.021h.171a.056.056,0,0,0,.085,0h.214a.449.449,0,0,0,.3,0Z",
    transform: "translate(0 -42.3)",
    fill: "#fd960f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16174",
    "data-name": "Path 16174",
    d: "M184.37,42.3a.275.275,0,0,1-.3,0Z",
    transform: "translate(-173.564 -42.3)",
    fill: "#ff9e24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16175",
    "data-name": "Path 16175",
    d: "M198.587,42.3a.273.273,0,0,1-.3,0Z",
    transform: "translate(-186.969 -42.3)",
    fill: "#f8831f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16176",
    "data-name": "Path 16176",
    d: "M0,225.622a.215.215,0,0,1,0,.256Z",
    transform: "translate(0 -215.156)",
    fill: "#ffa02b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16177",
    "data-name": "Path 16177",
    d: "M178.918,42.3c-.028.042-.057.049-.085,0Z",
    transform: "translate(-168.625 -42.3)",
    fill: "#ffc57c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16178",
    "data-name": "Path 16178",
    d: "M0,245.077c.04.028.051.057,0,.085Z",
    transform: "translate(0 -233.501)",
    fill: "#ffc67e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16179",
    "data-name": "Path 16179",
    d: "M197.2,259.7a8.762,8.762,0,0,1-1.652,1.27,10.757,10.757,0,0,1-4.208,1.523,7.354,7.354,0,0,1-1.53.092.241.241,0,0,1-.1-.2c-.007-.107-.007-.213-.007-.32q0-3.989,0-7.978a1.238,1.238,0,0,1,.04-.464c.054-.128.173-.132.285-.144a5.4,5.4,0,0,0,1.562-.382,5.75,5.75,0,0,0,.541-.293c.086-.048.172-.11.272-.026a8,8,0,0,1,2.105,1.24,7.392,7.392,0,0,1,2.473,3.959,9.627,9.627,0,0,1,.217,1.724",
    transform: "translate(-178.876 -240.723)",
    fill: "#344f9e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16180",
    "data-name": "Path 16180",
    d: "M192.38,116.981c-.3.15-.583.339-.9.466a5.023,5.023,0,0,1-1.691.339l-.037-.022a.682.682,0,0,1-.071-.454q0-3.48,0-6.96c0-.434,0-.868,0-1.3,0-.111-.013-.233.1-.31v-.02a4.491,4.491,0,0,1,2.837,1.011,4.357,4.357,0,0,1,1.648,2.959,4.439,4.439,0,0,1-1.8,4.2,1.247,1.247,0,0,0-.091.088",
    transform: "translate(-178.849 -104.926)",
    fill: "#ffb65e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16181",
    "data-name": "Path 16181",
    d: "M69.678,253.822c0,.846-.006,1.692-.006,2.539q0,3.232,0,6.464a10.674,10.674,0,0,1-5.018-1.212,10.176,10.176,0,0,1-2.363-1.657,7.7,7.7,0,0,1,.44-2.5,7.352,7.352,0,0,1,4.37-4.429c.1-.078.186-.015.272.034a4.705,4.705,0,0,0,1.692.6c.207.029.43-.009.608.143Z",
    transform: "translate(-58.738 -240.962)",
    fill: "#5d6fb3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16182",
    "data-name": "Path 16182",
    d: "M116.669,117.977a4.492,4.492,0,0,1-2.367-.667c-.066-.04-.137-.074-.205-.112a6.254,6.254,0,0,1-.952-.912,4.525,4.525,0,0,1,2.884-7.3,2.34,2.34,0,0,1,.637-.042q0,4.515,0,9.031",
    transform: "translate(-105.732 -105.134)",
    fill: "#ffd298"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountPersonalInfo);
export default __webpack_public_path__ + "static/media/my-account-personal-info.897fc184981c014e4be71d929305fab6.svg";
export { ForwardRef as ReactComponent };